/** EstadisticasPage — Contenedor con 3 tabs: General, Productividad y Ejecutiva. */
import React, { useState } from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { BarChart3, AlertCircle, Gauge, TrendingUp, Users, MailSearch } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import GeneralTab from './estadisticas/GeneralTab';
import ProductividadTab from './estadisticas/ProductividadTab';
import EjecutivaTab from './estadisticas/EjecutivaTab';
import EmailHealthcheckTab from './estadisticas/EmailHealthcheckTab';

const TAB_ITEMS = [
  { key: 'general', label: 'General', icon: Gauge },
  { key: 'productividad', label: 'Productividad', icon: Users },
  { key: 'ejecutiva', label: 'Ejecutiva', icon: TrendingUp },
];

export default function EstadisticasPage() {
  const { empresa, user } = useAuth();
  const [tab, setTab] = useState('general');
  const esAdmin = ['ADMINISTRADOR', 'SUPERADMIN'].includes(user?.rol);
  const tabs = esAdmin
    ? [...TAB_ITEMS, { key: 'email-healthcheck', label: 'Email Healthcheck', icon: MailSearch }]
    : TAB_ITEMS;

  if (!empresa?.modulo_tickets_activo) {
    return (
      <div className="container mx-auto py-8 max-w-3xl">
        <Card><CardContent className="py-10 text-center text-slate-500">
          <AlertCircle className="w-10 h-10 mx-auto mb-3 text-amber-500" />
          <p className="font-medium text-slate-800">El módulo Centro de Ayuda no está activado.</p>
        </CardContent></Card>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-4 px-4 max-w-[1500px]">
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
          <BarChart3 className="w-6 h-6" /> Estadísticas
        </h1>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <TabsList className="h-auto bg-transparent p-0 gap-1 border-b border-slate-200 rounded-none w-full justify-start" data-testid="estadisticas-tabs">
          {tabs.map(({ key, label, icon: Icon }) => (
            <TabsTrigger
              key={key}
              value={key}
              data-testid={`tab-${key}`}
              className="rounded-none rounded-t-md border border-transparent border-b-0 px-4 py-2.5 -mb-px text-slate-500 data-[state=active]:bg-white data-[state=active]:text-[#4E6151] data-[state=active]:border-slate-200 data-[state=active]:shadow-none data-[state=active]:font-semibold data-[state=active]:border-b-2 data-[state=active]:border-b-[#4E6151] transition-all"
            >
              <Icon className="w-4 h-4 mr-2" /> {label}
            </TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="general" className="mt-5" data-testid="content-general"><GeneralTab /></TabsContent>
        <TabsContent value="productividad" className="mt-6" data-testid="content-productividad"><ProductividadTab /></TabsContent>
        <TabsContent value="ejecutiva" className="mt-6" data-testid="content-ejecutiva"><EjecutivaTab /></TabsContent>
        {esAdmin && (
          <TabsContent value="email-healthcheck" className="mt-6" data-testid="content-email-healthcheck"><EmailHealthcheckTab /></TabsContent>
        )}
      </Tabs>
    </div>
  );
}
